import {
  Box,
  Card,
  CardBody,
  Flex,
  Stack,
  StackDivider,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

export default function CardInbox({ data }) {
  return (
    <Link to={`/inbox/${data._id}`}>
      <Card
        mb={4}
        width="calc(100% - 16px)"
        position="relative"
        className="inbox-card"
        cursor="pointer"
      >
        <CardBody zIndex={2} borderRadius={8} backgroundColor="white">
          <Stack divider={<StackDivider />} spacing="2">
            <Flex alignItems="center">
              <Text
                fontSize="sm"
                textTransform="uppercase"
                fontWeight="semibold"
                color="gray.500"
              >
                {data.eventDetail.eventName}
              </Text>
              {data.attend && (
                <Text
                  fontSize="sm"
                  marginLeft={3}
                  padding="1px 8px"
                  backgroundColor="#77DD77"
                  color="#fff"
                  borderRadius={6}
                >
                  Hadir
                </Text>
              )}
            </Flex>
            <Box>
              <Text fontSize="sm" textTransform="uppercase" color="gray.500">
                Tanggal & Waktu
              </Text>
              <Text pt={1} fontSize={12}>
                {moment(data.eventDetail.date).format("dddd, DD MMMM YYYY")}
                {" | "}
                {`${data.eventDetail.startTime} - ${data.eventDetail.endTime}`}
              </Text>
            </Box>
          </Stack>
        </CardBody>
      </Card>
    </Link>
  );
}
